import { render, staticRenderFns } from "./MeetupsPage.vue?vue&type=template&id=0068ff48&"
import script from "./MeetupsPage.vue?vue&type=script&lang=js&"
export * from "./MeetupsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports